import { defined } from '../../util';

export default function renderAttr(name, value) {
    return (defined(value) && value !== null) ? (" " + name + "=\"" + value + "\" ") : "";
}


// WEBPACK FOOTER //
// ./node_modules/@progress/kendo-drawing/dist/es/svg/utils/render-attribute.js